export const SUBTRACT_MOBILE_BET_COUNT = 'SUBTRACT_MOBILE_BET_COUNT';
export const ADD_MOBILE_BET_COUNT = 'ADD_MOBILE_BET_COUNT';
export const RESET_MOBILE_BET_COUNT = 'RESET_MOBILE_BET_COUNT';
export const SET_MOBILE_BET = 'SET_MOBILE_BET';
export const RESET_MOBILE_BET = 'RESET_MOBILE_BET';
export const MOBILE_BET_INIT = 'MOBILE_BET_INIT';
export const SET_MOBILE_BET_TO_STATE = 'SET_MOBILE_BET_TO_STATE';
export const SET_MOBILE_BET_TRACK_READY = 'SET_MOBILE_BET_TRACK_READY';
export const SET_MOBILE_BET_PRODUCT_READY = 'SET_MOBILE_BET_PRODUCT_READY';
